import { useClient } from './useClient';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { RULE_ID } from './useRule';

export default function useDeleteServiceConfigMutation(
  ruleId: string,
  serviceConfigId: string | null,
) {
  const { client } = useClient('detection');
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      client.delete(
        `/rules/${ruleId}/service-configs/${serviceConfigId}`,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [RULE_ID, ruleId] });
    },
  });
}
